"use strict";

var _defineProperty = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var yup = _interopRequireWildcard(require("yup"));
var _formik = require("formik");
var _colors = require("../config/colors.config");
var _breakpoints = _interopRequireDefault(require("../config/breakpoints"));
var _validation = require("./utils/validation");
var _helpers = require("./utils/helpers");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var coffeeImg = (0, _helpers.getImageByAgent)('coffee.svg');
var CallMePopover = function CallMePopover(props) {
  var isMobile = (0, _core.useMediaQuery)("(max-width:".concat(_breakpoints.default.mobile, "px)"));
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Popover, {
    open: props.open,
    anchorReference: isMobile ? 'anchorPosition' : 'anchorEl',
    anchorEl: props.anchorEl,
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    transformOrigin: {
      horizontal: isMobile ? 'center' : 'right',
      vertical: isMobile ? 'top' : 'bottom'
    },
    anchorPosition: {
      left: 0,
      top: 250
    },
    className: classes.popover,
    onClose: props.onClose
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    style: {
      width: isMobile ? '' : '550px'
    },
    p: 3
  }, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    onSubmit: props.onSubmit,
    validationSchema: yup.object().shape({
      name: _validation.hebrewOnly,
      phone: _validation.validPhone
    }),
    initialValues: {
      name: '',
      phone: ''
    }
  }, function (_ref) {
    var values = _ref.values,
      errors = _ref.errors,
      touched = _ref.touched,
      handleChange = _ref.handleChange,
      handleSubmit = _ref.handleSubmit;
    return !props.callMeSubmitted ? /*#__PURE__*/_react.default.createElement(_formik.Form, {
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      spacing: 4
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, isMobile ? /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: classes.dismisBox
    }, /*#__PURE__*/_react.default.createElement("span", {
      role: "button",
      tabIndex: 0,
      onClick: props.onClose,
      onKeyPress: props.onClose,
      className: classes.dismisButton
    })) : false, /*#__PURE__*/_react.default.createElement(_core.Box, {
      ml: 1,
      className: classes.messageText
    }, props.message)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 4
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      className: classes.textField,
      name: "name",
      onChange: handleChange,
      value: values.name,
      label: "\u05E9\u05DD",
      error: errors.name && touched.name
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 4
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      className: classes.textField,
      name: "phone",
      onChange: handleChange,
      value: values.phone,
      label: "\u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF",
      error: errors.phone && touched.phone
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 4
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      type: "submit",
      variant: 'outlined'
    }, "\u05D4\u05EA\u05E7\u05E9\u05E8\u05D5 \u05D0\u05DC\u05D9\u05D9")))) : /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      spacing: 4
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, isMobile ? /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: classes.dismisBox
    }, /*#__PURE__*/_react.default.createElement("span", {
      role: "button",
      tabIndex: 0,
      onClick: props.onClose,
      onKeyPress: props.onClose,
      className: classes.dismisButton
    })) : false, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      alignItems: "center",
      justify: "center",
      container: true,
      spacing: 4,
      direction: "row",
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      className: classes.messageText
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.title1
    }, props.message), props.secondaryMessage ? /*#__PURE__*/_react.default.createElement("div", {
      className: classes.title2
    }, props.secondaryMessage) : false), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: coffeeImg,
      alt: "coffee"
    })))));
  })));
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _popover;
  return {
    dismisBox: {
      position: 'relative',
      textAlign: 'right'
    },
    dismisButton: {
      '&:after': {
        transform: 'rotate(-45deg)'
      },
      '&:before': {
        transform: 'rotate(45deg)'
      },
      '&:before, &:after': {
        borderBottom: "2px solid ".concat(_colors.Black[170]),
        content: '""',
        display: 'block',
        position: 'absolute',
        width: 20
      },
      display: 'inline-block',
      height: 10,
      left: -5,
      position: 'relative',
      width: 20
    },
    messageText: _defineProperty({
      color: theme.palette.secondary.dark,
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 600
    }, theme.breakpoints.down('sm'), {
      fontSize: theme.typography.pxToRem(18)
    }),
    popover: (_popover = {
      '& .MuiPopover-paper': _defineProperty({
        '& .MuiButton-sizeLarge': {
          backgroundColor: theme.palette.background.paper
        },
        backgroundColor: "".concat(theme.palette.background.default, " !important"),
        border: '1px solid #E5E5E5'
      }, theme.breakpoints.up('md'), {
        '& .MuiButton-sizeLarge': {
          paddingBottom: 12,
          paddingTop: 12
        }
      })
    }, _defineProperty(_popover, theme.breakpoints.down('sm'), {
      backgroundColor: 'rgba(118,118,118,0.63)'
    }), _defineProperty(_popover, "border", '1px solid #E5E5E5'), _popover),
    textField: {
      '& .MuiInputBase-root': {
        backgroundColor: theme.palette.background.paper
      }
    },
    title1: {
      color: _helpers.agentDeveloperUtils.getSecondaryColor(300),
      fontSize: 26,
      fontWeight: 700,
      marginTop: 20
    },
    title2: {
      color: _colors.Black[300],
      fontSize: 16
    }
  };
});
CallMePopover.propTypes = {
  anchorEl: _propTypes.default.any,
  callMeSubmitted: _propTypes.default.bool,
  message: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  onClose: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  open: _propTypes.default.bool,
  secondaryMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
};
var _default = exports.default = CallMePopover;